import React from 'react'

const RectangleDashed = ({color = '#3F5063'}) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color} d="M52,47.1h-8.6c-0.6,0-1-0.4-1-1s0.4-1,1-1H51v-7.6c0-0.6,0.4-1,1-1s1,0.4,1,1v8.6C53,46.6,52.6,47.1,52,47.1z
	 M19.2,47.1H12c-0.6,0-1-0.4-1-1v-8.6c0-0.6,0.4-1,1-1s1,0.4,1,1v7.6h6.2c0.6,0,1,0.4,1,1S19.7,47.1,19.2,47.1z M52,28.5
	c-0.6,0-1-0.4-1-1v-7.5h-7.6c-0.6,0-1-0.4-1-1s0.4-1,1-1H52c0.6,0,1,0.4,1,1v8.5C53,28,52.6,28.5,52,28.5z M12,28.5
	c-0.6,0-1-0.4-1-1v-8.5c0-0.6,0.4-1,1-1h8.6c0.6,0,1,0.4,1,1s-0.4,1-1,1H13v7.5C13,28,12.6,28.5,12,28.5z"/>
    </svg>
  )
}

export default RectangleDashed
